export default __webpack_public_path__ + "static/media/Horizontal zone.da07346c.jpg";